(function($, d, g) {
	
	'use strict';
	var tabBtn;
    
    var changeTabContent = function() {
        var t = $(this);
        var href = t.attr("data-href");

        if (!t.hasClass('selected')) {
            tabBtn.addClass('disabled-events');
            
            if (href !== "" && href !== undefined) {
                location.href = href;
            } else {
                var parentCtn = t.closest('.tabs-bar-and-content-ctn');
                var chosenTabNumber = t.data('tab');

                parentCtn.find('.tabs-bar-item.selected').removeClass('selected');
                parentCtn.find('.tabs-bar-item[data-tab=' + chosenTabNumber + ']').addClass('selected');
                parentCtn.find('.tabs-content-inner-ctn.selected').fadeOut(300, function() {
                    $(this).removeClass('selected');
                    parentCtn.find('.tabs-content-inner-ctn[data-tab=' + chosenTabNumber + ']').fadeIn(300).addClass('selected');
                    tabBtn.removeClass('disabled-events');
                });
            }
        }
    };
	
	var init = function () {
        tabBtn = $('.tabs-bar-item');
        tabBtn.click(changeTabContent);
	};
	
	$(g).on("load", init);
	
})(jQuery, document, window);
